import React, { useCallback, useEffect } from 'react';
import { isDesktop } from 'react-device-detect';

import { useFullscreen } from '@core/dashboard/hooks/fullscreen';
import { sendCustomSentryBreadcrumb } from '@helpers/sentry';

import FullScreenButtonView from './FullScreenButtonView';

const FullScreenButton = () => {
  const { toggleFullscreen, isFullscreen } = useFullscreen();

  const handleFullscreenClick = useCallback(() => {
    sendCustomSentryBreadcrumb({ message: 'show in full screen' });
    toggleFullscreen();
  }, [toggleFullscreen]);

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'F11') {
        event.preventDefault();
        handleFullscreenClick();
      }
      // Shift-Command-F in macOS Chrome is used to hide address bar and open full screen
      if (event.code === 'KeyF' && event.metaKey && event.shiftKey) {
        event.preventDefault();
        handleFullscreenClick();
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleFullscreenClick]);

  if (isDesktop) {
    return (
      <FullScreenButtonView
        isFullscreen={isFullscreen}
        onClick={handleFullscreenClick}
      />
    );
  }

  return null;
};

export default FullScreenButton;
